
import Vue from 'vue';

const filter = function (value: any, property: string) {
    if (!value) return '';

    return value[property];
};

Vue.filter('checkNull', filter);